import {POSTERMYWALL_HEADING_TEXT_TYPE} from '@FormMakerReact/components/postermywall-heading-text/postermywall-heading-text';
import {registerRightPanelSector} from '@FormMakerReact/layout/form-maker-right-panel/right-panel-registry';
import {HeadingFontControl} from './components/heading-font-control/heading-font-control';
import {HeadingSizeControl} from './components/heading-size-control/heading-size-control';
import {HeadingTextColorControl} from './components/heading-text-color-control/heading-text-color-control';

registerRightPanelSector(POSTERMYWALL_HEADING_TEXT_TYPE, {
  title: window.i18next.t('pmwjs_form_maker_heading_sector_title'),
  controls: [HeadingFontControl, HeadingSizeControl, HeadingTextColorControl],
});
